import { ChecklistsContainer } from 'components/ideal-core-ui'
import s from './Checklists.scss'

const Checklists = () => {
  return (
    <div className={s.checklistsWrapper}>
      <ChecklistsContainer entity="contact" />
    </div>
  )
}

export default Checklists
